import { BASE_URL } from "config";
import * as base from "./_base";

export const endpoints = {
  list: `${BASE_URL}/api/v1/seo/template/photo/`,
  detail: (id) => `${BASE_URL}/api/v1/seo/template/photo/${id}/`,
};

export const seoTemplatePhotoListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const seoTemplatePhotoDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const seoTemplatePhotoUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const seoTemplatePhotoDelete = (token, data) => base.Delete(endpoints.detail, token, data);
